import { render } from "./ShorttermPlotsHeader.vue?vue&type=template&id=522a7df3"
import script from "./ShorttermPlotsHeader.vue?vue&type=script&lang=js"
export * from "./ShorttermPlotsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__